//////////////////////////////////////////////////////////////////
// Detect Visible Scrollbars
//////////////////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > document.documentElement.clientWidth) {
    document.documentElement.classList.add('visible-scrollbars');
  }
});
